import c from "lodash/isUndefined";
const s = {
  dp: 0.88,
  px: 1
};
function f(r, t, n) {
  return typeof n > "u" || +n == 0 ? Math[r](t) : (t = +t, n = +n, isNaN(t) || !(typeof n == "number" && n % 1 === 0) ? NaN : (t = t.toString().split("e"), t = Math[r](+`${t[0]}e${t[1] ? +t[1] - n : -n}`), t = t.toString().split("e"), +`${t[0]}e${t[1] ? +t[1] + n : n}`));
}
function d({ value: r, precision: t = 0, unit: n }) {
  return n ? `${f("floor", r / (s[n] || 1), -t)}${n}` : r;
}
function p({ value: r }) {
  return typeof r != "string" ? void 0 : String(r).match(/[\d.\-\+]*\s*(.*)/)[1] || "";
}
function g({ value: r, precision: t = 0 }) {
  if (typeof r != "string" || c(r))
    return r;
  const n = String(r), o = parseFloat(n, 10), i = n.match(/[\d.\-\+]*\s*(.*)/)[1] || "";
  return s[i] ? f("ceil", o * s[i], -t) : o;
}
function m(r) {
  if (c(r))
    return 0;
  const t = r.toString(), n = t.indexOf(".");
  let o = 0;
  return n !== -1 && (o = t.length - n - 1), o;
}
function e(r, t = 0) {
  const n = 10 ** t;
  return parseFloat(Math.round(r * n) / n);
}
function S(r, t, n, o) {
  if (typeof r != "number" && !c(r))
    return o;
  const i = 10 ** n;
  return e((i * r - i * t) / i, n);
}
function h(r, t, n, o) {
  if (typeof r != "number" && !c(r))
    return o;
  const i = 10 ** n;
  return e((i * r + i * t) / i, n);
}
export {
  S as decrease,
  d as formatOutputValue,
  m as getPrecision,
  h as increase,
  p as parseIncomingUnit,
  g as parseIncomingValue,
  e as toPrecision
};
//# sourceMappingURL=utils.js.map
